module.exports = __webpack_public_path__ + "static/media/iso-125-2022.c111d153.pdf";